module.exports = __webpack_public_path__ + "static/moo-logo-2e4d470419cf8b6f0bd405a00032fc52.png";